import {RainbowResponseChannel} from '../../server/rainbow/types';
import {getHeaderLanguageCode} from '../../shared/utils/getHeaderLanguageCode';
import {parseJson} from '@treatwell/ui';
import {httpGetText} from './http';
import {cachifyPromise} from 'cachify-promise';

export const fetchCachedChannel = cachifyPromise(
  async ({languageCode}: {languageCode?: string | null}) => {
    const headers = getHeaderLanguageCode(languageCode);
    const response = await httpGetText<string>({
      path: '/api/v1/channel',
      options: {
        headers,
      },
    });

    return parseJson<RainbowResponseChannel>(response);
  },
);
